import { Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import AlertIcon from 'react-feather/dist/icons/alert-triangle';
import QueryToolbar from './QueryToolbar';
import { JupiterTheme } from '../../theme/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: theme.spacing(2),
    },
    noResultsIcon: {
      flex: 2,
      width: '3em',
      height: '3em',
      color: theme.palette.error.dark,
    },
    noResultsTitle: {
      flex: 1,
      color: theme.palette.error.dark,
    },
    noResultsText: {
      flex: 6,
      whiteSpace: 'pre-line',
    },
  })
);

const ErrorQueryResults = ({
  message,
  query,
  onRemoveResult,
}: {
  message: string;
  query: string;
  onRemoveResult?: VoidFunction;
}) => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <QueryToolbar query={query} onRemoveResult={onRemoveResult} hideAlert />
      <AlertIcon className={classes.noResultsIcon} />
      <Typography variant="h6" className={classes.noResultsTitle}>
        There was an error with this query
      </Typography>
      <Typography variant="caption" className={classes.noResultsText}>
        {message.replaceAll('|', '\n')}
      </Typography>
    </Paper>
  );
};

export default ErrorQueryResults;
